import fetch from 'unfetch'
import Queue from 'yocto-queue'

const DEBUG_API_ENDPOINT = import.meta.env.VITE_DEBUG_API_ENDPOINT!
const MAX_QUEUE_SIZE = 10e3
class Logger {
  readonly queue: Queue<any>
  private numDropped: number
  debugMode: boolean
  constructor() {
    this.debugMode = false
    this.queue = new Queue()
    this.numDropped = 0
  }

  async initialise() {
    await fetch(DEBUG_API_ENDPOINT, {
      method: 'GET',
    })
      .then(async (res) => {
        if (res.ok) {
          const data = await res.json()
          if (data.enabled) {
            console.warn(
              '[OfferKit] debug mode has been temporarily enabled by a remote service.'
            )
          }
          this.setDebugMode(data.enabled)
        } else {
          console.warn('[OfferKit] could not resolve debug mode from server.')
        }
      })
      .catch(() => {
        console.warn('[OfferKit] could not resolve debug mode from server.')
      })
  }

  setDebugMode(flag: boolean) {
    this.debugMode = flag
    if (flag) {
      this.evaluateQueue()
    }
  }

  log(...data: any[]) {
    const fn = () => console.log('[OfferKit]', ...data)
    if (this.debugMode) {
      fn()
    } else {
      this.addToQueue(fn)
    }
  }

  error(...data: any[]) {
    console.error('[OfferKit]', ...data)
  }

  warn(...data: any[]) {
    console.warn('[OfferKit]', ...data)
  }

  private addToQueue(fn: () => void) {
    while (this.queue.size >= MAX_QUEUE_SIZE) {
      this.numDropped++
      this.queue.dequeue()
    }
    this.queue.enqueue(fn)
  }

  private evaluateQueue() {
    if (this.numDropped > 0) {
      this.warn(
        this.numDropped,
        'logs had been dropped as queue size was exceeded.'
      )
    }
    while (this.queue.size) {
      const fn = this.queue.dequeue() as () => void
      fn()
    }
  }
}

export const logger = new Logger()
